<template>
  <div class="layout-box" :class="{ layout2: property_data.type === 2 }">
    <!-- 不加key， 没有唯一值， 用index有可能更新不渲染 -->
    <div
      class="card-box"
      :style="`background-color:${property_data.background_color};`"
      v-for="(item, index) in showData"
      @click="jump(item.id)"
    >
      <div class="left">
        <div
          class="card-title ellipsis"
          :style="`background-color: ${property_data.subtitle_bg_color}`"
        >
          {{ item.subtitle }}
        </div>
        <div
          class="card-item-title ellipsis"
          :style="`color: ${property_data.title_color}`"
          v-if="property_data.type === 2"
        >
          {{ item.title }}
        </div>
        <el-image class="card-image" fit="contain" :src="item.img_url"></el-image>
        <div
          class="card-item-title ellipsis"
          :style="`color: ${property_data.title_color}`"
          v-if="property_data.type === 1"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="right">
        <div class="sales-list" v-if="property_data.type === 1">
          <div
            class="item-sale"
            :style="`border: 1px solid ${property_data.sale_color};`"
            v-for="(sale, inx) in item.sales"
            :key="inx"
          >
            <div class="sale-sl ellipsis">
              <span
              :style="
                `color: ${index === 1 ? property_data.sale_color : 'inherit'};`
              "
              v-for="(saleItem, index) in sale.split('\\')"
              :key="index"
            >
              {{ saleItem }}
            </span>
            </div>
          </div>
          <div class="sale-desc" :style="`color: ${property_data.desc_color};`">{{ item.sale_desc }}</div>
        </div>

        <div class="btn-sl">
          <div class="btn-box">
          <div
            class="btn-left ellipsis"
            :style="
              `color: ${property_data.btn_lf_text_color}; background: linear-gradient(0deg, ${btn_lf_bg[0]}, ${btn_lf_bg[1]});`
            "
          >
            <span class="price-text">到手价:</span
            ><span class="price-number" :style="`font-size: ${item.price.toString().length > 5 ? (17/item.price.toString().length)+'rem' : '3.5rem'}`">{{ item.price }}</span>
          </div>
          <div
            class="btn-right"
            :style="
              `background: linear-gradient(0deg, ${btn_rt_bg[0]}, ${btn_rt_bg[1]});`
            "
          >
            <div
              class="commission-box ellipsis"
              :style="`color: ${property_data.btn_rt_text_color}`"
            >
              <span class="commission-text">佣金:</span
              ><span class="commission">{{ item.commission }}%</span>
            </div>
            <div class="buy-btn">
              <div
                class="buy-text"
                :style="
                  `color: ${property_data.btn_lf_text_color};background: linear-gradient(0deg, ${btn_lf_bg[0]}, ${btn_lf_bg[1]});`
                "
              >
                立即抢购 >
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {redirectURL} from '@/js/jump';
export default {
  name: "tms-active-day",
  props: ["config", "isEditorStatus", "pageData"],
  data() {
    return {};
  },
  computed: {
    app_type () {
      return this.pageData.app_type || 'seller'
    },
    showData() {
      if (this.listData.length) {
        return this.listData;
      }
      return this.notData;
    },
    notData() {
      const obj = {
        img_url:
          "https://mktv-in-cdn.mockuai.com/16397202064747389.png",
        subtitle: "限时榜单主推款",
        title: "蔬小简卡控蛋白特膳",
        price: 278.99,
        commission: "43.33",
        sales: [
          "销量第一名奖励\\2000元",
          "销量第二名奖励2000元",
          "销量第三名奖励2000元",
          "销量第四名奖励200元",
          "销量第五名奖励20元"
        ],
        sale_desc: "参与排名条件：销量满1000单以上"
      };
      if (this.property_data.type === 2) {
        return [obj, obj];
      } else {
        return [obj];
      }
    },
    listData() {
      if (this.property_data.list && this.property_data.list.length) {
        return this.property_data.list;
      }
      return [];
    },
    btn_lf_bg() {
      const bg = this.property_data.btn_lf_bg;
      if (!Array.isArray(bg)) {
        return [];
      }
      return bg;
    },
    btn_rt_bg() {
      const bg = this.property_data.btn_rt_bg;
      if (!Array.isArray(bg)) {
        return [];
      }
      return bg;
    },
    property_data() {
      return this.config.property_data;
    }
  },
  methods: {
    jump(id) {
      if (this.isEditorStatus) {
        return;
      }
      redirectURL(String(id), this.app_type);
    },
    scaleBox() {
      const base = 375
      const bodyW = document.body.clientWidth
      const ratio = bodyW/base
      return `background: scale(${ratio});`
    },
  }
};
</script>

<style scoped>
.layout-box {
  margin: 0 10px;
  transform: scale();
}
.layout-box .card-box {
  display: flex;
  padding: 0.8rem 1.4rem;
}

.layout2 {
  display: grid;
  grid-column-gap: 2.81%;
  grid-template-columns: 48.595% 48.595%; 
  /* 不用1fr是因为内容撑开会把容器撑开， 用了overflow， 会把title的效果在容器外面部分截取了 */
}

.layout2 .card-box {
  padding: 0.9rem 0.7rem;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}

.card-box {
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
  margin-bottom: 10px;
}

.layout2 .card-image {
  width: 12.5rem;
  height: 12.5rem;
  margin-left: calc((100% - 12.5rem) / 2);
}

.layout2 .left {
  width: 100%;
  margin-right: 0;
}
.layout2 .right {
  width: 100%;
}

.left {
  width: 13.5rem;
  margin-right: 2.4rem;
}
.right {
  flex-shrink: 0;
  width: 15.7rem;
  text-align: center;
}

.layout2 .card-title {
  margin: 0 4px;
  margin-top: -1.8rem;
}
.layout2 .card-item-title {
  font-size: 1.5rem;
  line-height: 1;
  margin-bottom: 8px;
  margin-top: 8px;
  font-weight: 500;
  transform: scale(1);
  width: 100%;
}

.card-title {
  height: 1.9rem;
  border-radius: 1rem;
  color: #fff;
  font-size: 1.2rem;
  text-align: center;
  line-height: 1.9rem;
  margin-bottom: 5px;
  padding: 0 5px;
  box-sizing: border-box;
}
.card-image {
  width: 100%;
  height: 13.5rem;
  margin-bottom: 6px;
  border-radius: 4px;
  background-color: #fff;
}
.card-item-title {
  color: #0c0c0c;
  opacity: 0.83;
  text-align: center;
  transform-origin: 0 0;
  transform: scale(0.5);
  font-size: 2rem;
  width: 200%;
  /* 20 => 10 */
}

.sales-list {
  margin-top: 1.7rem;
  margin-bottom: 0.9rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 0.5rem;
  box-sizing: border-box;
  height: 13rem;
}
.item-sale {
  height: 1.9rem;
  border-radius: 10px;
  padding: 0 0.6rem;
  margin-bottom: 0.4rem;
  text-align: left;
}
.sale-sl {
  transform: scale(0.5);
  transform-origin: 0 0;
  width: 200%;
  font-size: 2.4rem;
  line-height: 3.8rem;
}
.sale-desc {
  font-size: 1.4rem;
  line-height: 1.4rem;
  height: 1.4rem;
  transform-origin: 0 0;
  transform: scale(0.5);
  width: 200%;
}

.btn-sl{
  height: 3rem;
  overflow: hidden;
}

.btn-box {
  display: flex;
  height: 6rem;
  transform-origin: 0 0;
  transform: scale(0.5);
  width: 200%;
}

.btn-left {
  width: 16.2rem;
  height: 100%;
  line-height: 6rem;
  border-radius: 0.6rem 0px 0px 0.6rem;
  display: inline-block;
  vertical-align: middle;

  box-sizing: border-box;
}
.btn-right {
  width: 15.2rem;
  height: 100%;
  border-radius: 0px 0.6rem 0.6rem 0px;
  text-align: left;
  padding: 0 1.6rem;
  box-sizing: border-box;
}
.price-text {
  display: inline-block;
  font-size: 1.6rem;
  font-weight: 500;
  margin-right: 0.2rem;
}
.price-icon {
  display: inline-block;
  font-size: 2.2rem;
}
.price-number {
  font-size: 3rem;
  font-family: 'mockuai';
}

.commission-box {
  margin-top: 0.8rem;
  text-align: center;
}
.commission-text {
  display: inline-block;
  font-weight: 500;
  font-size: 1.4rem;
  margin-right: 0.4rem;
}
.commission {
  font-weight: bold;
  font-size: 2rem;
}

.buy-btn {
  width: 100%;
  height: 2.2rem;
  background: linear-gradient(0deg, #fc6f84, #fc9380);
  border-radius: 5px;
  line-height: 2.2rem;
  margin-top: 0.3rem;
}
.buy-text {
  font-size: 1.4rem;
  text-align: center;
}

.ellipsis {
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
